import gql from "graphql-tag";

const onUpdateContent = gql`
  subscription OnUpdateContent($channel_id: String) {
    onUpdateContent(channel_id: $channel_id) {
      id
      channel_id
      title
      date
      created_at
      status
      stream_url
      stream_mode
      autoplay
      mute
      poster
      poster_upload
    }
  }
`;

export { onUpdateContent };
